<template>
  <div class="mic-com seckill-container">
    <div class="seckill" :style="goodsStyle">
      <GoodsChunk v-for="chunk in chunkList"
                  chunk-type="seckill"
                  :key="chunk.key"
                  :config="config"
                  :data="chunk"
                  :preview="preview">
        <template v-slot="{goods, index}">
          <GoodsCard
                  :index="index"
                  :key="goods.guid"
                  :config="config"
                  :data="goods"/>
        </template>
      </GoodsChunk>
      <div class="seckill-all-btn"
           v-if="config.show_all_btn&&config.goods_from===1"
           :style="{marin: config.goods_margin / 2 + 'px'}">
        <van-button size="large" :url="config.more_link_url">查看全部</van-button>
      </div>
      <div class="empty" v-if="!chunkList.length">
        <van-image src="https://files.1card1.cn/VipCloudSite/159168/20200401/1b6aee76ccef425594413a2a368d2986.png" style="height: 250px;"/>
      </div>
    </div>
  </div>
</template>

<script>
  import * as shop from '@/api/shop';
  import GoodsCard from "./GoodsCard";
  import ChunkList from '../mixins/ChunkList';
  import Common from '../mixins/Common';

  export default {
	name: 'Seckill',
	props: {},
	mixins: [Common, ChunkList],
	components: {GoodsCard},
	data() {
	  return {
		chunkList: [],
		observerKeys: [
		  'config.goods_from',
		  'config.guids',
		  'config.goods_number'
		],
		request: shop.getSeckillList
	  };
	},
	created() {
	  this.observerWhenPreview();
	  this.createChunkList();
	},
	methods: {
	  getQuery(query) {
		return {
		  ...query,
		  order: this.config.order_rule
		};
	  }
	},
	computed: {}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .seckill-container {
    overflow: hidden;

    .seckill {
      overflow: hidden;
    }

    .seckill-all-btn {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
</style>
